module.exports = __webpack_public_path__ + "jp.svg?07631708aaeb9d4553ed29039d79fe9a";